export interface Post {
  slug: string;
  title: string;
  description: string;
  category: string;
  author: string;
  date: string;
  readingTime: string;
  cover: string;
  excerpt: string;
  content: { heading: string; body: string }[];
  faq?: { q: string; a: string }[];
}

export const CATEGORIES = [
  "Gestão",
  "Empreendedorismo",
  "Estratégia",
  "Finanças",
  "Vendas e Marketing",
  "Produtividade",
  "Inovação",
  "Tecnologia",
  "Carreira e RH",
  "Cases de Sucesso",
] as const;

// Os artigos vivem no banco de dados (tabela public.posts) e são gerados
// pela ferramenta editorial do painel administrativo. Mantemos a lista vazia
// apenas como compatibilidade de tipo para imports legados.
export const POSTS: Post[] = [];

export const findPost = (slug: string) => POSTS.find((p) => p.slug === slug);
export const relatedPosts = (slug: string, limit = 3) =>
  POSTS.filter((p) => p.slug !== slug).slice(0, limit);
